import {BaseModel} from "./BaseModel";

export class Folder extends BaseModel{
    static entity = 'Household\\Model\\Folder';
    static modelKey = 'folders';

    static fields() {
        return {
            id: this.attr(null),
            email: this.attr(null),
            household_id: this.attr(''),
            name: this.attr(null),
            ancestry: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(true),
        }
    }

    static apiConfig = {
        actions: {
            fetchHouseholdRootFolders(householdId) {
                return this.post(`households/${householdId}/folders/search`, {
                    filters: [
                        {field: 'ancestry', operator: '=', value: null},
                    ]
                })
            },

            fetchSubFolders(folderId) {
                return this.get(`folders/${folderId}/subfolders`);
            },

            fetchDocuments(folderId) {
                return this.get(`folders/${folderId}/documents`);
            }
        }
    }
}
